import { ClientSummarySortField } from 'anchor-scout-common/types';
import { dynamicColumnId, dynamicColumnKey } from '~/components/DynamicColumns/DynamicColumns.utils';
export const clientReferenceFieldsColumnSource = {
    id: 'ref',
    entries: (client)=>client.referenceFields,
    bi: {
        name: 'clients_by_reference_field'
    }
};
export const referenceColumnId = (key)=>dynamicColumnId(clientReferenceFieldsColumnSource, key);
const referenceKeyOf = (columnId)=>dynamicColumnKey(clientReferenceFieldsColumnSource, columnId);
export const referenceFiltersOf = (selection)=>Object.fromEntries(Object.entries(selection).flatMap((param)=>{
        let [columnId, values] = param;
        const key = referenceKeyOf(columnId);
        return key == null ? [] : [
            [
                key,
                values
            ]
        ];
    }));
export const REFERENCE_FILTER_EVERY_VALUE = '';
export const SELECT_ALL_REFERENCE_FILTER = [
    REFERENCE_FILTER_EVERY_VALUE
];
export const isSelectAllReferenceFilter = (values)=>values.length === 1 && values[0] === REFERENCE_FILTER_EVERY_VALUE;
export const referenceFilterSelection = (filters, everyOptionOf)=>Object.fromEntries(Object.entries(filters).map((param)=>{
        let [key, values] = param;
        return [
            referenceColumnId(key),
            isSelectAllReferenceFilter(values) ? everyOptionOf(key) : values
        ];
    }));
export const REFERENCE_FILTER_MAX_VALUES = 100;
export const referenceFiltersParam = (filters)=>{
    const sendable = Object.entries(filters).filter((param)=>{
        let [, values] = param;
        return values.length > 0 && !isSelectAllReferenceFilter(values);
    });
    return sendable.length === 0 ? {} : {
        referenceFilters: JSON.stringify(Object.fromEntries(sendable))
    };
};
export const referenceSortParam = (sortName)=>{
    const key = referenceKeyOf(sortName);
    return key == null ? {} : {
        sortField: ClientSummarySortField.ReferenceField,
        sortKey: key
    };
};
export const formatCountForLocale = (count, locale)=>new Intl.NumberFormat(locale, {
        useGrouping: true
    }).format(count);
